import React, { useState, useEffect, useRef } from "react";
import ReactSelect, { components } from "react-select";
import { colors, fonts } from "../../assets/styles/theme.ts";
import { Close, InfoOutlined } from "@mui/icons-material";
import { RenderImgStyled } from "../Tables/TablesStyled.js";
import styled from "styled-components";
import FilterIcon from "../../assets/Icons/Buttons/Muestras/filter.svg";
import {
  TextField,
  InputAdornment,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  IconButton,
  Tooltip,
  Box,
  Typography,
} from "@mui/material";
import { Virtuoso } from 'react-virtuoso';


const Input = (props) => {
  const [placeholderSelect, setPlaceholderSelect] = useState("");
  const [activeLegendReactSelect, setActiveLegendReactSelect] = useState("");
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const containerRef = useRef(null);
  const propsInput = (data) => {
    const className = data?.className ? data.className : "inputComponent";
    const inputProp = data?.inputProp || false;
    const positionIcon = data?.positionIcon
      ? `${data?.positionIcon}Adornment`
      : "startAdornment";
    const icon = data?.icon || null;
    const iconSelect = (
      <div htmlFor="select-icon" className="icon">
        {icon}
      </div>
    );
    const placeholder = data?.placeholder || "";
    const label = data?.label || "";
    const readOnly = data?.InputProps?.readOnly || false;
    const inputSelect = data?.inputSelect || false;
    const datosSelect = data?.datosSelect || [];
    const datosselectdefault = data?.datosselectdefault || [];
    const typeRow = data?.typeRow || "";
    const name = data?.name || "";
    const inputform = data?.inputForm || "false";
    const nameregister = data?.nameRegister || "";
    const reactSelect = data?.reactSelect || false;


    return {
      className,
      inputProp,
      positionIcon,
      icon,
      placeholder,
      readOnly,
      inputSelect,
      datosSelect,
      datosselectdefault,
      typeRow,
      iconSelect,
      label,
      name,
      inputform,
      nameregister,
      reactSelect,

    };
  };
  const {
    className,
    inputProp,
    positionIcon,
    icon,
    placeholder,
    readOnly,
    inputSelect,
    iconSelect,
    label,
    datosselectdefault,
    name,
    reactSelect,

  } = propsInput(props);

  const validTextFieldProps = { ...props };
  const propsReactSelect = { ...props };
  delete validTextFieldProps.inputProp;
  delete validTextFieldProps.positionIcon;
  delete validTextFieldProps.typeRow;
  delete validTextFieldProps.datosSelect;
  delete validTextFieldProps.inputSelect;
  const optionsWithIndex = props?.options?.map((opt, i) => ({
    ...opt,
    customIndex: i,
  }));
  const customStylesHeader = (menuIsOpen) => ({
    container: (provided) => ({
      ...provided,
      zIndex: "auto",
    }),
    placeholder: (defaultStyles) => ({
      ...defaultStyles,
      fontFamily: fonts.primary,
      fontSize: "17px",
      fontWeight: 400,
      color: `${colors.blueDark}`,
    }),
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "#f8f7f7",
      border: "1px solid transparent",
      height: "38px",
      zIndex: "auto",
      borderRadius: "10px",
      boxShadow: state.isFocused ? "0 0 0 1px rgb(49 130 206 / 40%)" : "none",

      "&:hover": {
        border: "1px solid transparent",
      },
      "&:active": {
        border: "1px solid transparent",
      },

    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "white",
      zIndex: "9999",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? colors.lightTurquoise
        : state.isFocused
          ? colors.lightTurquoise
          : state.data.customIndex % 2 === 0
            ? "white"
            : colors.iceGrey,
      color: state.isSelected ? "white" : "inherit",
      cursor: "pointer",
      fontFamily: "roboto",
      ":active": {
        ...provided[":active"],
        backgroundColor: state.isSelected && colors.lightTurquoise,
        fontFamily: "roboto",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      fontFamily: "roboto",
      padding: "0px 5px",
      display: "block",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: "100%",
      lineHeight: "38px",

    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      display: menuIsOpen ? "none" : "flex",
    }),
  });
  const Control = ({ children, ...props }) => (
    <components.Control {...props}>
      {!props.selectProps.menuIsOpen && !props.hasValue && (
        <RenderImgStyled img={FilterIcon} />
      )}
      {children}
    </components.Control>
  );
  const CustomOption = (props) => {
    const { data, innerRef, innerProps, isFocused, options, isSelected } = props;

    if (!reactSelect) return null;
    const index = options.findIndex((opt) => opt.value === data.value);

    const alternatedBg = index % 2 === 0 ? colors.iceGrey : 'transparent';
    return (
      <Box
        ref={innerRef}
        {...innerProps}
        sx={{
          p: 1,
          cursor: 'pointer',
          backgroundColor: isSelected
            ? colors.lightTurquoise
            : isFocused
              ? colors.lightTurquoise
              : alternatedBg,
          color: isSelected
            && "white",
          '&:active': {

            backgroundColor: colors.lightTurquoise,
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: '10px',
            justifyContent: 'space-between',
          }}
        >
          <Typography sx={{ fontWeight: 500, fontSize: 14 }}>
            {data.label}
          </Typography>
          <Typography
            sx={{
              display: "flex",
              justifyContent: "end",
              width: "42%",
              fontWeight: 400,
              fontSize: 13
            }}>
            {data?.code ? `(${data.code})` : null}
          </Typography>
        </Box>

        <Typography sx={{ fontSize: 13, fontWeight: data.color ? "bold" : 400, color: data.color, }}>
          {data.subLabel}
        </Typography>
      </Box>
    );
  };

  const customStyles = {
    container: (provided) => ({
      ...provided,
      zIndex: "auto",
    }),
    placeholder: (defaultStyles, state) => ({
      ...defaultStyles,
      fontFamily: fonts.primary,
      // color: state.isDisabled ? `${colors.blueDark}` : ${colors.blueDark},
      color: `${colors.blueDark}`,
      fontSize: "17px",
      fontWeight: 400,
      letterSpacing: "0.2px",
    }),

    control: (provided, state) => ({
      ...provided,
      backgroundColor: "white",
      height: "55px",
      zIndex: "auto",
      borderRadius: "8px",

      boxShadow: state.isFocused ? colors.lightTurquoise : "none",
      border: props.borderColor && `5px solid ${props.borderColor}`,
      borderColor: state.isFocused || state.isHovered || activeLegendReactSelect ? colors.selectInput : colors.selectInput,
      "&:hover": {
        borderColor: !props.borderColor ? colors.lightTurquoise : props.borderColor,
      },
      "&:focused": {
        borderColor: !props.borderColor ? colors.lightTurquoise : props.borderColor,
      },
      "&:active": {
        borderColor: !props.borderColor ? colors.lightTurquoise : props.borderColor,
      },

      color: state.isDisabled ? `${colors.blueDark}` : 'black',
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "white",
      zIndex: "9999",

    }),
    menuList: (base) => ({
      ...base,
      maxHeight: '200px',
      overflowY: 'auto',
      "@media (max-width: 1400px)": {
        maxHeight: "130px"
      },
      "@media (max-width: 720px)": {
        maxHeight: "100px"
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? colors.lightTurquoise
        : state.isFocused
          ? colors.lightTurquoise
          : state.data.customIndex % 2 === 0
            ? "white"
            : colors.iceGrey,
      color: state.isSelected ? "white" : "inherit",
      cursor: "pointer",
      fontFamily: "roboto",
      ":active": {
        ...provided[":active"],
        backgroundColor: state.isSelected && colors.lightTurquoise,
        fontFamily: "roboto",
      },
    }),
    singleValue: (provided, state) => ({
      ...provided,
      fontFamily: "roboto",
      padding: "0px 5px",
      color: colors.blueDark,
      maxWidth: "calc(100% - 40px)",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    }),
  };
  const defaultStyles = {
    "& .MuiInputBase-input": {
      fontFamily: fonts.primary,
      fontWeight: 400,
      fontSize: "16px",
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: colors.turquoise,
      },
      "&:hover fieldset": {
        borderColor: colors.turquoise,
      },
      // "fieldset": {
      //   borderColor: props.value ? colors.turquoise : colors.selectInput,
      // },
    },
  };
  const handleChangeReactSelect = (val) => {
    setActiveLegendReactSelect(val?.label ? val?.label : "");
  };
  const CustomMenuList = (props) => {
    const { options, children } = props;


    if (options.length <= 2) {
      return <div>{children}</div>;
    }


    const itemHeight = 42;
    const maxAllowedHeight = 300;
    const height = Math.min(maxAllowedHeight, options.length * itemHeight);

    return (
      <Virtuoso
        style={{ height }}
        totalCount={children.length}
        itemContent={(index) => children[index]}
      />
    );
  };
  useEffect(() => {
    if (props.value) {
      handleChangeReactSelect(props.value);
    }
  }, [props.value, props.onChange, setActiveLegendReactSelect]);

  useEffect(() => {
    if (props.showSelect != null) {
      setMenuIsOpen(props.showSelect);
    }
  }, [props.showSelect]);

  useEffect(() => {
    if (props.showSelect == null || !menuIsOpen) return;

    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setMenuIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [props.showSelect, menuIsOpen]);

  
  return (
    <Styled className={props.classnamediv ? props.classnamediv : "divInput"}>
      {reactSelect ? (
        <div
          ref={containerRef}
          style={{
            ...props.styledReactSelect,
            position: "relative",
            padding: "5px 0px",

          }}
        >
          {placeholder && activeLegendReactSelect?.length > 0 && (
            <div
              style={{
                background:
                  "linear-gradient(to bottom, white 60%, #F7F7F8 30%)",
                position: "absolute",
                top: "-5px",
                left: "10px",
                padding: "0px 5px",
                zIndex: 99,
                fontFamily: "inter",
                color: colors.blueDark,
                fontSize: "13px",
                fontWeight: 400,
                letterSpacing: "0.2px",
              }}
            >
              {placeholder}
            </div>
          )}


          <ReactSelect
            {...propsReactSelect}
            isClearable={props.isClearable}
            options={optionsWithIndex ? optionsWithIndex : props.options}
            placeholder={placeholder}
            value={props.value}

            onChange={(e) => {
              setMenuIsOpen(false);
              handleChangeReactSelect(props.value ? props.value : e);
              if (props.onChange) {
                props.onChange(e);
              }
            }}
            styles={props.stylesHeader ? customStylesHeader(menuIsOpen) : customStyles}
            components={{
              ...(props.showSubLabel && { Option: CustomOption }),
              ...(props.stylesHeader && { Control }),
              MenuList: CustomMenuList,
            }}
            filterOption={(option, inputValue) => {
              const input = inputValue.toLowerCase();
              const label = option.label?.toLowerCase() || "";

              if (props.showSubLabel) {
                const code = option.data?.code?.toLowerCase?.() || "";
                return label.includes(input) || code.includes(input);
              }

              return label.includes(input);
            }}
            {...(props.showSelect !== undefined && {
              menuIsOpen: menuIsOpen,
              onMenuOpen: () => setMenuIsOpen(true),
              onMenuClose: () => setMenuIsOpen(false),
            })}
          />


        </div>
      ) : inputSelect ? (
        <FormControl className={className}>
          <InputLabel htmlFor="select-icon">{placeholder}</InputLabel>
          {iconSelect}
          <Select
            {...validTextFieldProps}
            value={placeholderSelect}
            label={placeholder}
            name={name}
            onChange={(e) => {
              setPlaceholderSelect(e.target.value);
              props.onChange && props.onChange(e);
            }}
            inputProps={{
              id: "select-icon",
            }}
            renderValue={placeholderSelect !== "" ? undefined : null}
          >
            {datosselectdefault &&
              datosselectdefault.map((option, key) => (
                <MenuItem key={key} value={option}>
                  {option.label}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      ) : (
        <TextField
          {...validTextFieldProps}
          className={className}
          placeholder={placeholder}
          label={label}
          name={name}
          InputLabelProps={{
            shrink: props.shrink,
            style: {
              fontSize: '17px',
              color: `${colors.blueDark}`,
              top: "-2px", fontWeight: 400,
              left: "-4px",
              letterSpacing: "0.5px",
            },
          }}
          InputProps={{
            [positionIcon]:
              props.search && inputProp ? (
                <InputAdornment position="start">{icon}</InputAdornment>
              ) : null,

            endAdornment: (
              <>
                {props.showTooltip && (
                  <InputAdornment position="end">
                    <Tooltip

                      componentsProps={{
                        tooltip: {
                          sx: {
                            backgroundColor: colors.blueDark,
                            color: "#ffffff",
                            border: `3px solid ${colors.turquoise}`,
                            borderRadius: 3,
                            boxShadow: 3,
                            p: 1.5,
                            maxWidth: 250,
                          },
                        },
                        arrow: {
                          sx: {
                            color: "#fefefe",
                          },
                        },
                      }}
                      title={
                        <Box p={1} >
                          <Typography variant="subtitle2" fontWeight={600} gutterBottom>
                            {props.tooltipTitle}
                          </Typography>
                          <Typography variant="body2" sx={{ maxWidth: 220 }}>
                            {props.tooltipDescription}
                          </Typography>
                        </Box>
                      }
                      arrow
                      placement="top"
                    >
                      <InfoOutlined
                        fontSize="small"
                        color="primary"
                        sx={{
                          cursor: "pointer",
                          mr: props.search && props.value?.length > 0 ? 0.5 : 0,
                        }}
                      />
                    </Tooltip>
                  </InputAdornment>
                )}

                {props.search && props.value?.length > 0 && (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => {
                        if (props.isClearable) {
                          props.isClearable();
                        }
                      }}
                      disableRipple
                    >
                      <Close />
                    </IconButton>
                  </InputAdornment>
                )}
              </>
            ),

            readOnly: readOnly,
          }}
          sx={{
            ...defaultStyles,
            ...props.sx,
          }}
        />
      )}
    </Styled>
  );
};

export default Input;

const Styled = styled.div`
  .Mui-disabled {
    -webkit-text-fill-color: ${colors.blueDark};
  }
  .MuiInputBase-input.MuiOutlinedInput-input.Mui-disabled {
    -webkit-text-fill-color: ${colors.blueDark};
  }
  .MuiOutlinedInput-notchedOutline.Mui-disabled {
    fieldset {
      border-color: rgba(0, 0, 0, 0.5);
    }
  }
  .inputDefault {
  }
  .inputComponent {
    border-radius: 20px;
    background-color: #f6f8f8;
    width: 100%;
    fieldset {
      border: none;
    }
  }

  .inputSelect {
    border-radius: 20px;
    background-color: #f6f8f8;
    .icon {
      position: absolute;
      top: 10px;
      font-size: 20px;
      left: 10px;
      z-index: 1;
    }
    label {
      top: -5px;
      left: 20px;
    }
    .MuiSelect-select {
      padding: 10px 35px;
      font-size: 15px;
      font-family: Inter;
    }
    width: 100%;
    fieldset {
      border: none;
      
    }
  }
`;
